// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { GenericPost } from '../../../../types/server/modules/generic/post';

export type * from '../../../../types/server/modules/generic/post';

export const createPost = ( requests: Requests ): GenericPost => ({
  upload_image: Object.assign(( body,headers ) => {
      return requests.post( `/images/upload`, { body }, headers, true );
    }, { operation: 'generic:upload-image', route: 'POST /images/upload', subdomain: 'generic', visibility: 'private' } as const ),
  upload_file: Object.assign(( body,headers ) => {
      return requests.post( `/files/upload`, { body }, headers, true );
    }, { operation: 'generic:upload-file', route: 'POST /files/upload', subdomain: 'generic', visibility: 'private' } as const )
});
